import Axios from "axios";
import isLive from "./isLive";
const servers = [
  process.env.REACT_APP_APP_DEV_DOMAIN,
  process.env.REACT_APP_APP_LIVE_DOMAIN,
  "http://127.0.0.1:8000/api",
];
let api = servers[0];

if (isLive()) {
  api = servers[1];
}
if(window.location.hostname==='localhost')
  {
    api = servers[0];
   
  }
const headers = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

const API = Axios.create({
  baseURL: api,
  headers,
});

const Serialize = (formData) => {
  var object = {};
  formData.forEach((value, key) => {
    object[key] = value;
  });
  return JSON.stringify(object);
};
window.SerializeFormData = Serialize;

export default API;
